import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navigation from './components/Navigation';

import FullstackPage from './pages/recrutement/FullstackPage';
import InternshipPage from './pages/recrutement/InternshipPage';
import TechLeadPage from './pages/recrutement/TechLeadPage';

import SYSTAC2Page from './pages/solutions/docs/mxpay/systac2/SYSTAC2Page';
import ProcessDetailPage from './pages/solutions/docs/mxpay/systac2/ProcessDetailPage';
import ArchitecturePage from './pages/solutions/docs/mxpay/architecture/ArchitecturePage';
// Pages R&D UEMOA
import BlockchainTradeFinance from './pages/solutions/r&d/UEMOA/BlockchainTradeFinance';
import UemoaRTGSAnalysis from './pages/solutions/r&d/UEMOA/UemoaRTGSAnalysis';
import OpenBankingUEMOA from './pages/solutions/r&d/UEMOA/OpenBankingUEMOA';
import OpenBankingMaroc from './pages/solutions/r&d/UEMOA/OpenBankingMaroc';

// Pages R&D CEMAC
import GIMACAnalysis from './pages/solutions/r&d/CEMAC/GIMACAnalysis';
import CEMACFinanceAnalysis from './pages/solutions/r&d/CEMAC/CEMACFinanceAnalysis';

// Pages R&D Pays
import KenyaDigitalFinance from './pages/solutions/r&d/Kenya/KenyaDigitalFinance';
import CIDigitalFinance from './pages/solutions/r&d/CI/CIDigitalFinance';
import SmartSenegalAnalysis from './pages/solutions/r&d/Senegal/SmartSenegalAnalysis';
import DigitalMaliAnalysis from './pages/solutions/r&d/Mali/DigitalMaliAnalysis';

// Pages R&D World
import CBPRPlusAnalysis from './pages/solutions/r&d/World/CBPRPlusAnalysis';

// Pages Solutions
import Landing from './pages/solutions/Landing';
import Portfolio from './pages/solutions/Portfolio';
import ProductPage from './pages/solutions/ProductPage';
import Factory from './pages/solutions/Factory';
import Integration from './pages/solutions/Integration';
import Consulting from './pages/solutions/consulting';
import FinancialInnovationShowcase from './pages/solutions/FinancialInnovationShowcase';

// Pages Academy
import AcademyLanding from './pages/academy/Landing';
import Catalog from './pages/academy/Catalog';
import CourseDetail from './pages/academy/CourseDetail';
import ServiceCorporate from './pages/academy/ServiceCorporate';
import ServiceCustom from './pages/academy/ServiceCustom';
import ServiceSubscription from './pages/academy/ServiceSubscription';

// Documentation
import DocsPage from './pages/docs/DocsPage';

// Pages Services
import ServicesLanding from './pages/services/landing';
import Amoa from './pages/services/Amoa';
import Support from './pages/services/support';
import Audit from './pages/services/audit';

// Pages générales
import About from './pages/About';
import Contact from './pages/Contact';
import Privacy from './pages/Privacy';
import Terms from './pages/Terms';
import Login from './pages/Login';
import Register from './pages/Register';

const App = () => {
  return (
    <Router>
      <div className="min-h-screen bg-[#050A1C]">
        <Navigation />
        
        <div className="pt-16">
          <Routes>
		  
		  <Route path="/recrutement/fullstack" element={<FullstackPage />} />
<Route path="/recrutement/internship" element={<InternshipPage />} />
<Route path="/recrutement/techlead" element={<TechLeadPage />} />


            {/* Routes pour la documentation */}
            <Route path="/docs/:productId" element={<DocsPage />} />

            {/* Routes Solutions */}
            <Route path="/" element={<Landing />} />
            <Route path="/portfolio" element={<Portfolio />} />
            <Route path="/product/:productId" element={<ProductPage />} />
            <Route path="/factory" element={<Factory />} />
            <Route path="/integration" element={<Integration />} />
            <Route path="/consulting" element={<Consulting />} />
            <Route path="/rd-showcase" element={<FinancialInnovationShowcase />} />

            {/* Routes Academy */}
            <Route path="/academy" element={<AcademyLanding />} />
            <Route path="/academy/catalog" element={<Catalog />} />
            <Route path="/academy/course/:courseId" element={<CourseDetail />} />
            <Route path="/academy/corporate" element={<ServiceCorporate />} />
            <Route path="/academy/custom" element={<ServiceCustom />} />
            <Route path="/academy/subscription" element={<ServiceSubscription />} />

            {/* Routes Services */}
            <Route path="/services" element={<ServicesLanding />} />
            <Route path="/services/amoa" element={<Amoa />} />
            <Route path="/services/support" element={<Support />} />
            <Route path="/services/audit" element={<Audit />} />

            {/* Routes générales */}
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />

            {/* Routes R&D */}
            <Route path="/rd-showcase/UEMOA/BlockchainTradeFinance" element={<BlockchainTradeFinance />} />
            <Route path="/rd-showcase/UEMOA/UemoaRTGSAnalysis" element={<UemoaRTGSAnalysis />} />
            <Route path="/rd-showcase/UEMOA/OpenBankingUEMOA" element={<OpenBankingUEMOA />} />
            <Route path="/rd-showcase/UEMOA/OpenBankingMaroc" element={<OpenBankingMaroc />} />

            <Route path="/rd-showcase/CEMAC/GIMACAnalysis" element={<GIMACAnalysis />} />
            <Route path="/rd-showcase/CEMAC/CEMACFinanceAnalysis" element={<CEMACFinanceAnalysis />} />

            <Route path="/rd-showcase/Kenya/KenyaDigitalFinance" element={<KenyaDigitalFinance />} />
            <Route path="/rd-showcase/CI/CIDigitalFinance" element={<CIDigitalFinance />} />
            <Route path="/rd-showcase/Senegal/SmartSenegalAnalysis" element={<SmartSenegalAnalysis />} />
            <Route path="/rd-showcase/Mali/DigitalMaliAnalysis" element={<DigitalMaliAnalysis />} />

            <Route path="/rd-showcase/World/CBPRPlusAnalysis" element={<CBPRPlusAnalysis />} />
            



  <Route path="/docs/mxpay/systac2" element={<SYSTAC2Page />} />
  <Route path="/docs/mxpay/systac2/process/:processId" element={<ProcessDetailPage />} />

  <Route path="/docs/:productId" element={<DocsPage />} />
<Route path="/docs/mxpay/architecture" element={<ArchitecturePage />} />

  <Route path="/" element={<Landing />} />


			
		 </Routes>
        </div>
        
        <footer className="bg-[#003B3B] border-t border-white/10">
          <div className="container mx-auto px-4 py-8">
            <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
              <p className="text-white/50">© 2025 KG Technologies. All rights reserved.</p>
              <div className="flex flex-col md:flex-row gap-4 md:gap-6">
                <a href="/terms" className="text-white/50 hover:text-white transition-colors">
                  Conditions d'utilisation
                </a>
                <a href="/privacy" className="text-white/50 hover:text-white transition-colors">
                  Politique de confidentialité
                </a>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </Router>
  );
};

export default App;